import styled, { css } from 'styled-components';

// Import icons
import { ReactComponent as IconCloseSVG } from 'assets/icons/ic_close_thin.svg';

// Import components
import { Button } from 'components/elements';

// Import utilties
import { customMinResponsive, size } from 'components/styles';

export const ButtonClose = styled(Button)`
	position: absolute;
	top: 2rem;
	right: 0.6rem;
	z-index: 100;

	svg > g > g {
			fill: ${({ theme }) => theme.modal.closeButton}
	}

	&:hover,
	&:focus {
		cursor: pointer;

		svg > g > g {
			fill: ${({ theme }) => theme.modal.closeButtonHover}
	}

	${customMinResponsive(
		size.medium,
		css`
			right: 2rem;
		`
	)};
`;

export const IconClose = styled(IconCloseSVG)`
	position: relative;
`;
